import {Box} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

const CompareLabel = ({sx, ...props}) => (
  <Box
    {...props}
    sx={[
      {
        position: 'absolute',
        left: 0,
        bottom: 0,
        bgcolor: 'grey.900',
        padding: 0.5,
        borderRadius: '4px 4px 0px 0px',
        color: 'white',
        fontSize: 'caption.fontSize',
      },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  />
);

CompareLabel.propTypes = {
  sx: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};

export default CompareLabel;
